import React, { useEffect, useState } from "react";
import "./Checkout.css";
import { useNavigate } from "react-router-dom";
import Breadcrumb_comp from "../common_components/breadcrumb-comp/Breadcrumb_comp";
import Payment_Summary from "../cart/payment_summary/Payment_Summary";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faWallet } from "@fortawesome/free-solid-svg-icons";
import Green_Btn from "../common_components/common_btn/green_btn/Green_Btn";
import OrderPlacedSuccessfullModal from "../common_components/common_modal/OrderPlacedSuccessfullModal/OrderPlacedSuccessfullModal";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import {
  createOrder,
  getAllOrderAddress,
  getAllOrderAddressBilling,
  getBillingOrderAddress,
  getSingleOrderAddress,
  OrderCalculation,
  OrderResponse,
} from "../../features/order/orderSlice";
import { Form } from "react-bootstrap";
import useRazorpay from "react-razorpay";
import { useForm } from "react-hook-form";
import { getNotifications } from "../../features/notifications/notificationSlice";
import { getAllWalletHistory } from "../../features/wallet/walletSlice";
import { appSetup, OrderTimeSlot } from "../../features/master/masterSlice";
import dayjs from "dayjs";
import { convertTo12Hour } from "../../utils/common";

const Checkout = ({ setDeliveryNote, deliveryNote, ...props }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [paymentValue, setPaymentValue] = useState(5);
  const [paymentData, setPaymentData] = useState({});
  const [CouponData, setCouponData] = useState("");
  const [trackId, setTrackId] = useState();

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [error, setErrors] = useState();
  const [addressId, setAddressId] = useState();

  const [GSTNumber, setGSTNumber] = useState("");
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const dispatch = useDispatch();
  const allAddress = useSelector((state) => state.order.allOrdersAddress);

  const allBillingAddress = useSelector(
    (state) => state.order.allBillingAddress
  );

  // const handleClick = () => {
  //   setShowModal(true);
  //   setTimeout(() => {
  //     setModalShow(false); // Optional: close modal before navigating
  //     navigate("/");
  //   }, 3000); // 3 seconds
  // };
  const handleManualClose = () => {
    setManualClose(true); // Prevent auto navigation
    setShowModal(false);
  };

  const handleClick = () => {
    handleManualClose();
    navigate("/"); // Fallback automatic navigation if needed
  };

  const parts = [
    props?.orderAddress?.building,
    props?.orderAddress?.street,
    props?.orderAddress?.apartment,
    props?.orderAddress?.Users_Address_Detail?.Country?.name,
    props?.orderAddress?.Users_Address_Detail?.State?.name,
    props?.orderAddress?.Users_Address_Detail?.City?.name,
    props?.orderAddress?.Users_Address_Detail?.Pincode?.name,
  ];

  const cart = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    // if (user?.id) {
    dispatch(getAllOrderAddress());
    dispatch(getAllOrderAddressBilling());
    // }
  }, []);

  useEffect(() => {
    if (props?.addressId) {
      setAddressId(props.addressId);
    } else if (Array.isArray(allAddress?.data) && allAddress.data.length > 0) {
      setAddressId(allAddress.data[0].id);
    }
  }, [props?.addressId, allAddress]);

  const [modalShow, setModalShow] = useState(false);

  const saveTotal = (cart) => {
    let total = 0;
    let savings = 0;
    let count = 0;

    if (cart?.data?.data?.length > 0) {
      for (const element of cart?.data?.data) {
        const price = Number(element?.Product_Variant?.price);
        const mrp = Number(element?.Product_Variant?.mrp);
        const qty = Number(element.quantity);
        total += price * qty;
        savings += (mrp - price) * qty;
        count += 1;
      }
    }
    const data = {
      total: total,
      savings: savings,
      count: count,
    };
    return data;
  };
  const [data, setData] = useState();

  useEffect(() => {
    const data = saveTotal(cart);
    setData(data);
  }, [cart]);

  const orderCalculation = async (addressId) => {
    const fallbackAddressId =
      Array.isArray(allAddress?.data) && allAddress?.data.length > 0
        ? allAddress.data[0].id
        : null;

    const data = {
      address_id: props?.addressId || fallbackAddressId,
    };

    if (CouponData) {
      data.coupon_id = CouponData.id;
    }

    const res = await dispatch(OrderCalculation(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setPaymentData(res?.payload?.data);
    } else if (res.meta?.requestStatus === "rejected") {
      // handle error
    }
  };

  // const orderCalculation = async (addressId) => {
  //   const data = {
  //     address_id: props?.addressId || allAddress?.data[0]?.id,
  //   };

  //   if (CouponData) {
  //     data.coupon_id = CouponData.id;
  //   }
  //   const res = await dispatch(OrderCalculation(data));
  //   if (res.meta?.requestStatus === "fulfilled") {
  //     setPaymentData(res?.payload?.data);
  //   } else if (res.meta?.requestStatus === "rejected") {
  //   }
  // };

  useEffect(() => {
    orderCalculation(addressId);
  }, [addressId, CouponData]);

  const [razorid, setRazorId] = useState();
  const [Razorpay] = useRazorpay();
  const handleRazorpay = async (price) => {
    if (!selectedDate) {
      setErrors("Please select a date first!");
      return;
    }

    if (!selectedTime) {
      setErrors("Please select a Time first!");
      return;
    }
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "DPORT",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };
  const nevigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [manualClose, setManualClose] = useState(false);
  const finalFunction = async (razorpay) => {
    if (!selectedDate) {
      setErrors("Please select a date first!");
      return;
    }

    if (!selectedTime) {
      setErrors("Please select a Time first!");
      return;
    }
    setLoading(true);
    const datafinal = {
      address_id: props?.addressId || allAddress?.data[0]?.id,
      billing_address_id: props?.addressBillingId || allBillingAddress?.data[0]?.id,
      payment_method_id: paymentValue,
      order_summary: paymentData?.order_summary,
      order_Details_summary: paymentData?.order_Details_summary,
      delivery_note: deliveryNote,
      delivery_date: selectedDate,
      time_slot_id: selectedTime,
      gst_number: GSTNumber,
    };
    if (razorpay) {
      datafinal.payment_id = razorpay;
    }

    const res = await dispatch(createOrder(datafinal));

    if (res.meta?.requestStatus === "fulfilled") {
      if (res?.payload?.data?.redirectUrl) {
        dispatch(getAllCart(props?.isSignIn));
        setTrackId(res?.payload?.data);
        dispatch(getNotifications());
        window.location.href = res?.payload?.data?.redirectUrl;
        // if()
      } else {
        setTrackId(res?.payload?.data);
        dispatch(getAllCart(props?.isSignIn));
        // handleClick();
        setShowModal(true);
      }
      // navigate(res?.payload?.data?.redirectUrl);

      //
    } else if (res.meta?.requestStatus === "rejected") {
      if (res.payload?.payment_method_id) {
        alert("Please Select Payment Option!");
        // setError("paymentOption", {
        //     type: "manual",
        //     message: 'Please Select Payment Option',
        // });
      }
    }
  };

  // const walletHistory = useSelector((state) => state.wallet.allWalletHistory);
  // useEffect(() => {
  //   dispatch(getAllWalletHistory());
  // }, [dispatch]);

  const singleAddress = useSelector((state) => state.order.orderAddress);
  const billingOrderAddress = useSelector(
    (state) => state.order.billingOrderAddress
  );

  useEffect(() => {
    let addressId = props?.addressId;
    let addressBillingId = props?.addressBillingId;

    if (
      !addressId &&
      Array.isArray(allAddress?.data) &&
      allAddress.data.length > 0
    ) {
      addressId = allAddress.data[0].id;
    }

    if (addressId) {
      dispatch(getSingleOrderAddress({ id: addressId }));
    }

    if (
      !addressBillingId &&
      Array.isArray(allBillingAddress?.data) &&
      allBillingAddress.data.length > 0
    ) {
      addressBillingId = allBillingAddress.data[0].id;
    }

    if (addressId) {
      dispatch(getSingleOrderAddress({ id: addressId }));
    }

    if (addressBillingId) {
      dispatch(getBillingOrderAddress({ id: addressBillingId }));
    }
  }, [dispatch, props?.addressId, props?.addressBillingId, , allAddress]);

  const appstup = useSelector((state) => state.master.app_setup);
  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  const today = dayjs();
  let startDate;
  const currentHour = dayjs().hour();

  if (currentHour >= appstup?.order_time) {
    startDate = today.add(1, "day"); // tomorrow
  } else {
    startDate = today; // today
  }

  const dates = Array.from({ length: appstup?.delivery_range || 7 }, (_, i) => {
    const d = startDate.add(i, "day");
    return {
      day: d.format("ddd"),
      date: d.format("DD/MM"),
      fullDate: d.format("YYYY-MM-DD"),
    };
  });

  const timeSlot = useSelector((state) => state.master.time_slot);
  useEffect(() => {
    dispatch(OrderTimeSlot({ delivery_date: selectedDate }));
  }, [dispatch, selectedDate]);

  return (
    <section className="Cart Checkout">
      <Breadcrumb_comp
        breadcrumbs={[
          { label: "Home", link: "/", isActive: false },
          { label: "Cart", link: "/cart", isActive: false },
          { label: "CHECKOUT", link: "", isActive: true },
        ]}
        additionalClass="groceries "
      />

      <div className="container ">
        <div className="cart_main_container">
          <div className="data_holder">
            <div className="row">
              <div className="col-lg-8 col-md-12 col-sm-12 col-12">
                <div className="left_side_card">
                  <div className="gray_box_holder">
                    <div className="common_white_card">
                      <div className="img_holder">
                        <img
                          src="/assets/images/checkout/location.png"
                          className="left_img"
                        />
                      </div>

                      <div className="address_holder">
                        <b>Shipping Address </b>
                        <p className="type_text">
                          {" "}
                          <FontAwesomeIcon
                            icon={faBuilding}
                            className="inner_icon"
                          />
                          {singleAddress?.apartment},{singleAddress?.floor},
                          {singleAddress?.building},{singleAddress?.direction},
                          {singleAddress?.street},
                          {singleAddress?.city_id?.label},
                          {singleAddress?.state_id?.label},
                          {singleAddress?.country_id?.label},
                          {singleAddress?.pincode_id?.label}
                        </p>
                      </div>
                    </div>

                    <div className="common_white_card">
                      <div className="img_holder">
                        <img
                          src="/assets/images/checkout/location.png"
                          className="left_img"
                        />
                      </div>

                      <div className="address_holder">
                        <b>Billing Address </b>
                        <p className="type_text">
                          {" "}
                          <FontAwesomeIcon
                            icon={faBuilding}
                            className="inner_icon"
                          />
                          {billingOrderAddress?.apartment},
                          {billingOrderAddress?.floor},
                          {billingOrderAddress?.building},
                          {billingOrderAddress?.direction},
                          {billingOrderAddress?.street},
                          {billingOrderAddress?.city_id?.label},
                          {billingOrderAddress?.state_id?.label},
                          {billingOrderAddress?.country_id?.label},
                          {billingOrderAddress?.pincode_id?.label}
                        </p>
                      </div>
                    </div>

                    <div className="common_white_card ">
                      <Form.Check
                        type="radio"
                        label="Cash on Delivery"
                        name="paymentOption"
                        value="cash"
                        onClick={() => setPaymentValue(1)}
                        checked={paymentValue === 1}
                        // onChange={() => setFieldValue("paymentOption", "cash")}
                      />
                    </div>
                    <div className="common_white_card ">
                      <Form.Check
                        type="radio"
                        label="Online"
                        name="paymentOption"
                        value="razorpay"
                        onClick={() => setPaymentValue(5)}
                        checked={paymentValue === 5}
                        // onChange={() => setFieldValue("paymentOption", "cash")}
                      />
                    </div>
                    {/* {data?.total_amount >= walletHistory?.user_wallet?.amount}
                    <div className="common_white_card ">
                      <Form.Check
                        type="radio"
                        label="Wallet"
                        name="paymentOption"
                        value="razorpay"
                        onClick={() => setPaymentValue(4)}
                        checked={paymentValue === 4}
                        // onChange={() => setFieldValue("paymentOption", "cash")}
                      />
                    </div> */}

                    <div className="time_slot_holder">
                      {error && (
                        <p style={{ color: "red", marginTop: "8px" }}>
                          {error}
                        </p>
                      )}
                      <h3>Select Delivery Date</h3>
                      <div className="date_selector">
                        {dates.map((item, index) => (
                          <div
                            key={index}
                            className="date_box"
                            onClick={() => {
                              setSelectedDate(item.fullDate);
                              setErrors("");
                            }}
                          >
                            <span
                              className={`day ${
                                selectedDate === item.fullDate ? "active" : ""
                              }`}
                            >
                              {item.day}
                            </span>
                            <span className="date">{item.date}</span>
                          </div>
                        ))}
                      </div>
                      {/* <div className="date_selector">
                        {dates.map((item, index) => (
                          <div
                            key={index}
                            className="date_box"
                            onClick={() => setSelectedDate(index)}
                          >
                            <span
                              className={`day ${
                                selectedDate === index ? "active" : ""
                              }`}
                            >
                              {item.day}
                            </span>
                            <span className="date">{item.date}</span>
                          </div>
                        ))}
                      </div> */}

                      <h3>Select Time Slot</h3>
                      <div className="time_slot_list">
                        {timeSlot.map((slot, index) => (
                          <div
                            key={index}
                            className={`time_slot_box ${
                              selectedTime === slot?.id ? "active" : ""
                            }`}
                            onClick={() => {
                              setSelectedTime(slot?.id);
                              setErrors("");
                            }}
                          >
                            <span>{convertTo12Hour(slot.from)}</span>
                            <span className="to_text">To</span>
                            <span>{convertTo12Hour(slot.to)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                <Payment_Summary
                  loading={loading}
                  setLoading={setLoading}
                  GSTNumber={GSTNumber}
                  setGSTNumber={setGSTNumber}
                  isCheckoutPage
                  checkout_btn="Place Order"
                  checkoutAction={() => {
                    paymentValue === 5
                      ? // ? handleRazorpay(paymentData?.order_summary?.total_amount)
                        finalFunction()
                      : finalFunction();
                  }}
                  paymentValue={paymentValue}
                  setPaymentValue={setPaymentValue}
                  addressId={props?.addressId}
                  data={paymentData?.order_summary}
                  parts={parts}
                  disable={true}
                  CouponData={CouponData}
                  setCouponData={setCouponData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <OrderPlacedSuccessfullModal
        handleManualClose={handleManualClose}
        handleClick={handleClick}
        show={showModal}
        onHide={() => setShowModal(false)}
        baseLink={`/order-details/${trackId?.id}`}
      />
      {/* checkoutAction={() => {
                onClick = {() => {props?.paymentValue === 2 ? handleRazorpay(paymentData?.order_summary?.total_amount) : finalFunction()}}
                                    }} */}
    </section>
  );
};

export default Checkout;
